module.exports = __webpack_public_path__ + "img/landing-treatment-screen-main.980081cf.png";